import { render, staticRenderFns } from "./QuestionAvatar.vue?vue&type=template&id=5b1bc40c&scoped=true&"
import script from "./QuestionAvatar.vue?vue&type=script&lang=js&"
export * from "./QuestionAvatar.vue?vue&type=script&lang=js&"
import style0 from "./question-avatar.scss?vue&type=style&index=0&id=5b1bc40c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1bc40c",
  null
  
)

export default component.exports